import {
  LOAD_ARTICLES,
  LOAD_ARTICLES_SUCCESS,
  LOAD_ARTICLE_CATEGORIES,
  LOAD_ARTICLE_CATEGORIES_SUCCESS,
  LOAD_ARTICLE_TAGS,
  LOAD_ARTICLE_TAGS_SUCCESS,
  LOAD_CATEGORIES_LAST_ARTICLES,
  LOAD_CATEGORIES_LAST_ARTICLES_SUCCESS,
  LOAD_ARTICLE_BY_ID,
  LOAD_ARTICLE_BY_ID_SUCCESS,
  UPDATE_ARTICLE,
  UPDATE_ARTICLE_SUCCESS,
  DELETE_ARTICLE,
  DELETE_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_CATEGORY,
  UPDATE_ARTICLE_CATEGORY_SUCCESS,
  DELETE_ARTICLE_CATEGORY,
  DELETE_ARTICLE_CATEGORY_SUCCESS,
  UPDATE_ARTICLE_TAG,
  UPDATE_ARTICLE_TAG_SUCCESS,
  DELETE_ARTICLE_TAG,
  DELETE_ARTICLE_TAG_SUCCESS,
  CLEAR_ARTICLE_TAGS,
  CLEAR_ARTICLE_CATEGORIES,
} from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';
import { toggleArticleCategoryForm, toggleArticleForm, toggleArticleTagForm } from 'actions/ui/formActions';

// Begin loading of the articles
export const loadArticles = (payload, categoryId) => {
  return {
    type: LOAD_ARTICLES,
    payload: {
      ...payload,
      resource: 'articles',
      onSuccess: (response) => loadArticlesSuccess(response, categoryId),
      onErrorMessage: getIntlMessage('article.load.error'),
    },
  };
};

// Update articles if loading is succeed
export const loadArticlesSuccess = (articles, categoryId = null) => {
  return {
    type: LOAD_ARTICLES_SUCCESS,
    articles,
    categoryId,
  };
};

// Begin loading of the article by id
export const loadArticleById = (payload) => {
  return {
    type: LOAD_ARTICLE_BY_ID,
    payload: {
      ...payload,
      resource: `articles/${payload.articleId}`,
      onSuccess: loadArticleByIdSuccess,
      onErrorMessage: getIntlMessage('article.load.error'),
    },
  };
};

// Update article by id if loading is succeed
export const loadArticleByIdSuccess = (article) => {
  return {
    type: LOAD_ARTICLE_BY_ID_SUCCESS,
    article,
  };
};

// Begin loading of the article categories
export const loadArticleCategories = (payload) => {
  return {
    type: LOAD_ARTICLE_CATEGORIES,
    payload: {
      ...payload,
      resource: 'article-categories',
      onSuccess: loadArticleCategoriesSuccess,
      onErrorMessage: getIntlMessage('article.category.load.error'),
    },
  };
};

// Update article categories if loading is succeed
export const loadArticleCategoriesSuccess = (articleCategories) => {
  return {
    type: LOAD_ARTICLE_CATEGORIES_SUCCESS,
    articleCategories,
  };
};

// Begin loading of the article tags
export const loadArticleTags = (payload) => {
  return {
    type: LOAD_ARTICLE_TAGS,
    payload: {
      ...payload,
      resource: 'article-tags',
      onSuccess: loadArticleTagsSuccess,
      onErrorMessage: getIntlMessage('article.tag.load.error'),
    },
  };
};

// Update article tags if loading is succeed
export const loadArticleTagsSuccess = (articleTags) => {
  return {
    type: LOAD_ARTICLE_TAGS_SUCCESS,
    articleTags,
  };
};
export const clearArticleTags = () => {
  return {
    type: CLEAR_ARTICLE_TAGS,
  };
};

// Begin loading of the categories with last articles
export const loadCategoriesLastArticles = (onLoading) => {
  return {
    type: LOAD_CATEGORIES_LAST_ARTICLES,
    payload: {
      resource: 'article-categories',
      fields: ['lastArticles', 'categoryId'],
      extraFields: ['lastArticles'],
      onSuccess: loadCategoriesLastArticlesSuccess,
      onErrorMessage: getIntlMessage('article.load.error'),
      onLoading,
    },
  };
};

// Update categories with last articles if loading is succeed
export const loadCategoriesLastArticlesSuccess = (articles) => {
  return {
    type: LOAD_CATEGORIES_LAST_ARTICLES_SUCCESS,
    articles,
  };
};

export const clearArticleCategories = () => {
  return {
    type: CLEAR_ARTICLE_CATEGORIES,
  };
};

// Article update request
export const updateArticle = (values, resolve, reject, history, payload = {}) => {
  return {
    type: UPDATE_ARTICLE,
    promise: { resolve, reject },
    payload: {
      resource: 'articles',
      extraFields: ['tags', 'category'],
      onSuccess: updateArticleSuccess,
      afterSuccess: (response) => {
        if (history) {
          history.push('/wiki/articles/' + response.articleId);
        }
        return toggleArticleForm();
      },
      entityPrimaryKey: 'articleId',
      ...payload,
    },
    values,
  };
};

// Request to update some task fields
export const updateArticleFields = (values) => {
  return {
    type: UPDATE_ARTICLE,
    payload: {
      resource: 'articles',
      extraFields: ['tags'],
      onSuccess: updateArticleSuccess,
      entityPrimaryKey: 'articleId',
    },
    values,
  };
};

// Article update success
export const updateArticleSuccess = (article) => {
  return {
    type: UPDATE_ARTICLE_SUCCESS,
    article,
  };
};

// Sending a request to the server to delete article
export const deleteArticle = (articleId) => {
  return {
    type: DELETE_ARTICLE,
    payload: {
      resource: 'articles',
      entityId: articleId,
      onSuccess: deleteArticleSuccess,
      onErrorMessage: getIntlMessage('article.delete.error'),
    },
  };
};

// Delete article if sending succeed
export const deleteArticleSuccess = (articleId) => {
  return {
    type: DELETE_ARTICLE_SUCCESS,
    articleId,
  };
};

// Category update request
export const updateArticleCategory = (values, resolve, reject) => {
  return {
    type: UPDATE_ARTICLE_CATEGORY,
    promise: { resolve, reject },
    payload: {
      resource: 'article-categories',
      onSuccess: updateArticleCategorySuccess,
      afterSuccess: toggleArticleCategoryForm,
      entityPrimaryKey: 'categoryId',
    },
    values,
  };
};

// Category update success
export const updateArticleCategorySuccess = (category) => {
  return {
    type: UPDATE_ARTICLE_CATEGORY_SUCCESS,
    category,
  };
};

// Sending a request to the server to delete category
export const deleteArticleCategory = (categoryId) => {
  return {
    type: DELETE_ARTICLE_CATEGORY,
    payload: {
      resource: 'article-categories',
      entityId: categoryId,
      onSuccess: deleteArticleCategorySuccess,
      onErrorMessage: getIntlMessage('article.category.delete.error'),
    },
  };
};

// Delete category if sending succeed
export const deleteArticleCategorySuccess = (categoryId) => {
  return {
    type: DELETE_ARTICLE_CATEGORY_SUCCESS,
    categoryId,
  };
};

// Tag update request
export const updateArticleTag = (values, resolve, reject) => {
  return {
    type: UPDATE_ARTICLE_TAG,
    promise: { resolve, reject },
    payload: {
      resource: 'article-tags',
      onSuccess: updateArticleTagSuccess,
      afterSuccess: toggleArticleTagForm,
      entityPrimaryKey: 'tagId',
    },
    values,
  };
};

// Tag update request
export const createTag = (values, resolve, reject) => {
  return {
    type: UPDATE_ARTICLE_TAG,
    promise: { resolve, reject },
    payload: {
      resource: 'article-tags',
      onSuccess: updateArticleTagSuccess,
      entityPrimaryKey: 'tagId',
    },
    values,
  };
};

// Tag update success
export const updateArticleTagSuccess = (tag) => {
  return {
    type: UPDATE_ARTICLE_TAG_SUCCESS,
    tag,
  };
};

// Sending a request to the server to delete tag
export const deleteArticleTag = (tagId) => {
  return {
    type: DELETE_ARTICLE_TAG,
    payload: {
      resource: 'article-tags',
      entityId: tagId,
      onSuccess: deleteArticleTagSuccess,
      onErrorMessage: getIntlMessage('article.tag.delete.error'),
    },
  };
};

// Delete tag if sending succeed
export const deleteArticleTagSuccess = (tagId) => {
  return {
    type: DELETE_ARTICLE_TAG_SUCCESS,
    tagId,
  };
};
